import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository } from '@softline/core';
import { SOFTLINE_API_QUERY_SHELF_LABELS } from '../updated-article-label-print.api';
import { QueryShelfLabelRequest, ShelfLabelDefinition } from '../types';

@Injectable()
export class ShelfLabelRepository extends ReadonlyHttpApiCollectionRepository<
  ShelfLabelDefinition[],
  QueryShelfLabelRequest
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_QUERY_SHELF_LABELS);
  }

  protected override getLoadPayload(
    params: QueryShelfLabelRequest
  ): unknown | undefined {
    return params;
  }
}
